import {
  CreateDynamicSchema,
  FieldConfig,
  RequiredField,
} from "./formik";

// Configuration array defining validation rules
const config: FieldConfig[] = [

  RequiredField("commodity", "Commodity is required"),
   RequiredField("package", "Package type is required"),
   RequiredField("pieces", "Total pieces are required", true, "number"),
   RequiredField("weight", "Weight is required", true, "number"),
   RequiredField("itemCartonModelSerialNumber", "Does the shipment have (Item#, Carton#, Model#, Serial#) is required"),
   RequiredField("description", "Additional Details is required"),

];
// Function to create a Yup validation schema dynamically from the config array

// Exporting the dynamically created schema
export const ShortageEntryNBSchema = CreateDynamicSchema(config);

export const InitAllShortageFormValue = {
  itemCartonModelSerialNumber: undefined,
  weight: undefined,
  commodity: "",
  package: "",
  pieces: undefined,
  description: undefined,
};
